module.exports = "\n<h4 class=\"d-flex flex-justify-between flex-align-center\">\n    <div class=\" u-text--sc\">Attacks</div>\n    <button type=\"button\" class=\"btn--add u-sm\" (click)=\"add()\">New</button>\n</h4>\n<hr>\n\n<div *ngFor=\"let attack of attacks\">\n    <attack [attack]=\"attack\" (onEvent)=\"onEvent($event)\"></attack>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/attacks/attacks.component.html
// module id = ./src/app/attacks/attacks.component.html
// module chunks = main